import React from 'react'

const HeroBanner = () => {
  return (
    <div className="home__data">
        <h4 className="home__title">Quality and Performance</h4>
        <h2 className="home__subtitle">Mange Exports International</h2>
        <p className="home__description">Vast experience with the best products on the market</p>
        <a href="#" className="button">READ MORE
        <i className="ri-arrow-right-line"></i>
        </a>
    </div>
  )
}

export default HeroBanner